// src/components/home/HeroSection.jsx
// Greeting personal DENGAN NAMA USER tampil di sini

import React from 'react';
import { Sparkles, ChevronRight, Settings } from 'lucide-react';

export default function HeroSection({ userName = 'Santri', onStartAnalysis }) {
  const currentHour = new Date().getHours();
  const greeting =
    currentHour < 11 ? 'Selamat Pagi' :
    currentHour < 15 ? 'Selamat Siang' :
    currentHour < 18 ? 'Selamat Sore' : 'Selamat Malam';

  // Deteksi apakah user masih default (belum atur nama)
  const isDefault = !userName || userName === 'Santri';

  return (
    <div className="px-4 mb-5 mt-2 animate-fade-in">
      <div
        className="
          modern-card
          bg-gradient-to-br from-green-50 to-emerald-50
          dark:from-slate-800 dark:to-slate-700
          border-2 border-green-200 dark:border-green-700/30
          overflow-hidden relative
        "
      >
        {/* Decorative Orbs */}
        <div className="absolute -right-8 -top-8 w-32 h-32 bg-green-400/10 dark:bg-green-500/5 rounded-full blur-2xl"></div>
        <div className="absolute -left-4 -bottom-4 w-24 h-24 bg-emerald-400/10 dark:bg-emerald-500/5 rounded-full blur-xl"></div>

        <div className="relative z-10">
          {/* ── Greeting Personal DENGAN NAMA USER ────── */}
          <div className="mb-4">
            <div className="flex items-center space-x-2 mb-1.5">
              <span className="text-2xl">👋</span>
              <h1 className="text-xl font-extrabold text-stone-800 dark:text-slate-100">
                Halo, {userName}!
              </h1>
            </div>
            <p className="text-sm text-stone-600 dark:text-slate-300 leading-relaxed">
              {greeting}. Yuk bedah teks Arab bersama AI
            </p>
          </div>

          {/* ── Primary CTA Button ────────────────────── */}
          <button
            onClick={onStartAnalysis}
            className="
              w-full flex items-center justify-center gap-2
              bg-gradient-to-r from-green-500 to-green-600
              hover:from-green-600 hover:to-green-700
              text-white font-extrabold text-sm
              py-3.5 rounded-2xl
              shadow-lg shadow-green-500/20
              transition-all active:scale-95 group
            "
          >
            <Sparkles className="w-4 h-4 group-hover:rotate-12 transition-transform" />
            <span>Mulai Analisis</span>
            <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>

          {/* ── Hint untuk User Baru ──────────────────── */}
          {isDefault && (
            <button
              onClick={onStartAnalysis}
              className="
                w-full mt-3
                flex items-center justify-center gap-1.5
                bg-amber-50 dark:bg-amber-900/20
                border border-amber-200 dark:border-amber-800/40
                text-amber-700 dark:text-amber-400
                text-[10px] font-bold
                py-2 rounded-xl
                hover:bg-amber-100 dark:hover:bg-amber-900/40
                transition-all active:scale-95
              "
            >
              <Settings className="w-3 h-3" />
              <span>Atur nama kamu di Pengaturan untuk salam personal</span>
            </button>
          )}
        </div>
      </div>

      {/* Quick Stats Badge */}
      <div className="flex items-center justify-center space-x-2 text-[10px] text-stone-400 dark:text-slate-500 font-medium mt-3">
        <span>Belajar Paham</span>
        <span>•</span>
        <span>Istilah Nahwu</span>
        <span>•</span>
        <span>Gratis</span>
      </div>
    </div>
  );
}